<template>
    <div>
        <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Misc and Other Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        dense
                        rounded
                        required
                        v-model="selected_ay"
                        item-value="ay_id"
                        :items="academic_year_list"
                        item-text="academicyear"
                        label="Select Academic Year"
                        outlined
                        :loading="onloader"                  
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete v-model="registration_no" rounded :items="stud_list" label="Select Student" item-text="name" return-object outlined dense prepend-icon="mdi-account-child-circle" :loading="onloader"  @click="show = false"></v-autocomplete>
                </v-col>
                <v-btn class="button mt-3" v-if="registration_no != null" @click="getDetails()">Proceed</v-btn>
            </v-row>
            <v-row justify="center" v-if="show">
                <v-col cols="12" class="text-center">
                    <div class="py-2 px-4 d-inline-flex align-center rounded-lg"
                        style=" font-size:16px;">
                    <span><b>AY:</b> {{ current_ay }}</span>
                    <v-divider vertical class="mx-3"></v-divider>
                    <span><b>Standard:</b> {{ leaner_std }}</span>
                    <v-divider vertical class="mx-3"></v-divider>
                    <span><b>Division:</b> {{ leaner_div }}</span>
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center" v-if="show && misc_fees_list != ''">
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0f2027" rounded v-model="misc_fees" multiple :items="misc_fees_list" label="Select Misc Fee" item-text="amount" item-value="id" outlined dense></v-autocomplete>
                  </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-combobox color="#0f2027" rounded v-model="payment_mode" :items="payment_mode_list" label="Select Payment Mode" item-text="name" outlined dense></v-combobox>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field rounded label="Remark" outlined dense v-model="remark"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <input id="datePickerId" type="date" v-model="date_1" />
                </v-col>
                <center>
                    <v-btn small class="button" v-if="misc_fees != '' && misc_fees" @click="getAmountDetails(misc_fees)">Get Amount Details</v-btn>
                </center>
            </v-row>
                 <span v-if="show && show_details && misc_fees != ''">
                   <v-row justify="center" class="mb-2 mt-2">
                        <center>
                            <span v-for="(s, index) in miscfeesmaster" :key="index">{{ index + 1 }}.{{ s }} <br /></span>
                        </center>
                    </v-row>
                    <center><strong> Total Amount - </strong>{{ amount }}</center>
                    
                    <v-row justify="center" class="mt-2">
                        <form :action="url" v-if="pgs.includes('PayTM')" @submit="payment" name="paytmform" method="POST">
                            <input type="hidden" :value="orgid" name="orgid" />
                            <input type="hidden" :value="tenantid" name="tenantid" />
                            <input type="hidden" :value="uid" name="uid" />
                            <input type="hidden" :value="learner_id" name="studid" />
                            <input type="hidden" :value="amount" name="fee_amount" />
                            <input type="hidden" :value="ay" name="ay" />
                            <input type="hidden" :value="'Fees For- ' +miscfeesmaster" name="purpose" />
                            <input type="hidden" :value="id" name="json_pre_trans_data" />
                            <input type="hidden" :value="hash_val" name="hash_val" />
                            <v-btn small class="button" type="submit" :loading="loader">Pay Online</v-btn>
                        </form>                       
                        <form :action="razorpay_url" v-if="pgs.includes('RAZORPAY')" @submit="payment" name="paytmform"  method="POST">
                            <input type="hidden" :value="orgid" name="orgid" />
                            <input type="hidden" :value="tenantid" name="tenantid" />
                            <input type="hidden" :value="uid" name="uid" />
                            <input type="hidden" :value="learner_id" name="studid" />
                            <input type="hidden" :value="ay" name="ay"/>
                            <input type="hidden" :value="amount" name="fee_amount"/>
                            <input type="hidden" :value="'Misc - ' + miscfeesmaster" name="purpose"/>
                            <input type="hidden" :value="id" name="json_pre_trans_data"/>
                            <input type="hidden" :value="hash_val" name="hash_val"/>    
                            <input type="hidden" value="MISC" name="payment_type"/>    
                            <v-btn class="button" :loading="loader" v-if="amount != 0" small type="submit">Pay Online [RAZORPAY]</v-btn>
                        </form>
                        <v-btn class="button" v-if="misc_fees != null && misc_fees_list != ''" small @click="payOfflineFee()">Pay Offline</v-btn>
                    </v-row>
                </span>
                <!-- <v-btn class="button mt-3" v-if="misc_fees != null && misc_fees_list != ''" @click="payOfflineFee()">Pay</v-btn> -->
        </v-card>
        <v-card class="box" v-if="mics_other_fees_student_records != '' && show == true">
            <v-data-table v-if="mics_other_fees_student_records!=''" dense :headers="headers" :items="mics_other_fees_student_records" :search="search" class="elevation-1 mytable">
                <template v-slot:item.action="{ item }">
                    <v-tooltip top color="red">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mt-1 mb-1" rounded outlined small color="red" v-bind="attrs" v-on="on" @click="deletedialog(item.id)"> <v-icon small class="mr-1" color="red">mdi-delete-circle</v-icon>Delete</v-btn>
                        </template>
                        <span> Delete!!! </span>
                    </v-tooltip>
                </template>
                <template v-slot:item.print="{ item }">
                    <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no, item.ay)"> <v-icon small class="mr-1" color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                        </template>
                        <span> Print Fee Receipt!!! </span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
                        <v-row dense justify="center">
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Remark</b></p>
                                <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark"> </v-textarea>
                            </v-col>
                        </v-row>
                        <center>
                            <strong>Are you sure you want delete this fee???</strong>
                        </center>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
                            <v-btn class="button" text :disabled="addRemark != '' ? false : true" @click="deletestudent(addRemark)">Yes</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },
        data: () => ({
            child_info: null,
            // extraBreadcrumbItems: [

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            registration_no: null,
            stud_list: [],
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            misc_fees_list: [],
            payment_mode_list: [],
            payment_mode: null,
            misc_fees: null,
            remark: null,
            dialog_delete_option1: false,
            deleteItem_opt1: {
                delete_id1: "",
            },
            mics_other_fees_student_records: [],
            academic_year_list: [],
            selected_ay: null,
            loader: false,
            addRemark: "",
            learner_div_id: null,
            learner_id: null,
            tenantid: null,
            amount: null,
            miscfeesmaster: null,
            id: null,
            hash_val: null,
            orgid: null,
            show_details: false,
            uid: null,
            headers: [
                { text: "Sr. No.", value: "srno", sortable: false },
                { text: "Student Name", value: "stud_name", sortable: false },
                { text: "PRN No.", value: "prn_no", sortable: false },
                { text: "Class", value: "standard", sortable: false },
                { text: "Div", value: "division", sortable: false },
                { text: "Exam Name", value: "exam_name", sortable: false },
                { text: "Payment Mode", value: "payment_mode", sortable: false },
                { text: "Receipt No.", value: "receipt_no", sortable: false },
                { text: "Date", value: "paidon", sortable: false },
                // { text: "Amount to be collected", value: "ammount_to_collected", sortable: false },
                { text: "Amount Paid", value: "ammount_paid", sortable: false },
                { text: "Remaining", value: "remaining_amount", sortable: false },
                { text: "Action", value: "action", sortable: false },
                { text: "Print Receipt", value: "print", sortable: false },
            ],
            pgs:[],
            razorpay_url:null,
            onloader: false,
        }),
         created() {
          // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
          this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc";
          this.razorpay_url=process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate"
          // this.url_multiple = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc_multiple";
      },
        methods: {
          payment() {
              var formData = new FormData(paytmform);
              console.log("formData");
              console.log(formData);
              this.loader = false;
          },
            getAmountDetails(selectedTasks) {
                this.ay = null;
                this.id = null;
                this.amount = null;
                this.miscfeesmaster = null;
                this.learner_div_id = null;
                this.learner_id = null;
                this.tenantid = null;
                this.orgid = null;
                this.hash_val = null;
                this.uid = null;
                this.show_details = false;
                const data = {
                    child: this.registration_no.lid,
                    ay: this.selected_ay,
                    selectedTasks: selectedTasks,
                };
                axios
                    .post("/AccountingAndFees/getAmountDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay = res.data.ay;
                            this.id = res.data.id;
                            this.amount = res.data.amount;
                            this.miscfeesmaster = res.data.miscfeesmaster;
                            this.learner_div_id = res.data.learner_div_id;
                            this.learner_id = res.data.learner_id;
                            this.tenantid = res.data.tenantid;
                            this.orgid = res.data.orgid;
                            this.hash_val = res.data.hash_val;
                            this.uid = res.data.uid;
                            this.show_details = true;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                // this.$router.push({
                //     name: "misc-other-exam-fees-payment-receipt",
                // });
                let routeData = this.$router.resolve({
                    name: "misc-other-exam-fees-payment-receipt",
                });
                window.open(routeData.href, "_blank");
            },
            deletedialog(item) {
                this.dialog_delete_option1 = true;
                this.deleteItem_opt1.delete_id1 = item;
            },
            deletestudent(remark) {
                const formdata = {
                    id: this.deleteItem_opt1.delete_id1,
                    reason_for_delete: remark,
                };
                axios
                    .post("/AccountingAndFees/deletestudent", formdata)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dialog_delete_option1 = false;
                            this.showSnackbar("#4caf50", "Student Fee deleted successfully");
                            this.getDetails();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong !!!");
                            this.dialog_delete_option1 = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        this.dialog_delete_option1 = false;
                    })
                    .finally(() => {
                        this.dialog_delete_option1 = false;
                    });
            },
            payOfflineFee() {
                const formData = {
                    child: this.registration_no.registration_number,
                    misc_fee_id: this.misc_fees,
                    payment_mode_id: this.payment_mode.id,
                    remark: this.remark,
                    paid_on: this.date_1,
                    ay: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/payOfflineFee", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", "Misc Fee Paid Successfully..."); // show snackbar on success
                                this.getDetails();
                            } 
                            // else if (res.data.flag == "NO") {
                            //     this.showSnackbar("#b71c1c", "Misc Fee Already Paid!!!"); // show snackbar on error
                            // }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        this.misc_fees = null;
                        this.payment_mode = null;
                        this.remark = null;
                        this.ay = null;
                        this.id = null;
                        this.amount = null;
                        this.miscfeesmaster = null;
                        this.learner_div_id = null;
                        this.learner_id = null;
                        this.tenantid = null;
                        this.orgid = null;
                        this.hash_val = null;
                        this.uid = null;
                        this.show_details = false;
                        //alert("done")
                    });
            },
            getDetails() {
                //  alert(this.selected_ay)
                const formData = {
                    child: this.registration_no.registration_number,
                    ay: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/getMiscPaymentInfoOffline", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.show = true;
                            this.show_details = false;
                            this.misc_fees = null;
                            this.current_ay = res.data.current_ay;
                            this.leaner_std = res.data.leaner_std;
                            this.leaner_div = res.data.leaner_div;
                            this.misc_fees_list = res.data.misc_fees_list;
                            this.payment_mode_list = res.data.payment_mode_list;
                            this.mics_other_fees_student_records = res.data.mics_other_fees_student_records;
                            this.pgs = res.data.pgs;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("error","Something went wrong !!")
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            this.onloader = true;
            axios
                .post("/FeesStructureInstallment/getdata")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.academic_year_list = res.data.aylist;
                        this.onloader = false;
                        // this.selected_ay = res.data.current_ay;
                    } else {
                        this.showSnackbar("error","Something went wrong!!!");
                        this.onloader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("error","Something went wrong!!!");
                })
                .finally(() => {
                    this.onloader = false;
                });
        },
    };
</script>

<style scoped>
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
</style>
